import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SearchBoxIcon from "../../Assets/SearchIcon.svg";
import AddFolderIcon from "../../Assets/AddFolderIcon.png";
import folderIcon from "../../Assets/folderIcon.png";
import folder_actionIcon from "../../Assets/folder_actionIcon.png";
import ReactModal from "react-modal";
import "../../Styles/Folder/FolderListView.css";
import propertiesCloseIcon from "../../Assets/propertiesCloseIcon.svg";
import document_text from "../../Assets/document-text.png";
import tagfileicon from "../../Assets/tagfileicon.svg";
import selecyedFormIcon from "../../Assets/selecyedFormIcon.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import folderImage_start from "../../Assets/folderImage_start.png";
import closeIconselectedFolder from "../../Assets/closeIconselectedFolder.png";
import shareIcon from "../../Assets/shareIcon.svg";
import deleteIcon from "../../Assets/deleteIcon.svg";
import threedots from "../../Assets/threedots.svg";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineFileDownloadDone } from "react-icons/md";

const ProfileBasedLinks = styled.div`
  display: flex;
  gap: 20px;
  height: 100%;
`;

const CreateFormModel = ({ isOpen, onClose, getFolder, userId }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      minWidth: "30%",
      height: "80%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
      padding: "0px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
      zIndex: "999"
    },
  };

  const [folderName, setFolderName] = useState("");
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [forms, setForms] = useState([]);
  const URl = process.env.REACT_APP_API;

  const getForms = async () => {
    const response = await axios.get(`${URl}/index/${userId}`);
    if (response.status === 200) {
      setForms(response.data.data);
    }
  };
  useEffect(() => {
    getForms();
  }, []);

  function formatUpdatedAt(date) {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    return `Updated on ${formattedDate}`;
  }

  const handelSelectedFomes = (formId) => {
    if (selectedFormIds.includes(formId)) {
      setSelectedFormIds(selectedFormIds.filter((id) => id !== formId));
    } else {
      setSelectedFormIds([...selectedFormIds, formId]);
    }
  };

  const handelCreateFolderSubmit = async () => {
    const Url = process.env.REACT_APP_API;
    const data = {
      folderName,
      formIds: selectedFormIds,
    };
    try {
      const response = await axios.post(`${Url}/folder/create`, data);
      if (response.status === 200) {
        onClose();
        setFolderName("");
        setSelectedFormIds([]);
        getForms();
        getFolder();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handelCloseFolderModal = () => {
    onClose();
    setFolderName("");
    setSelectedFormIds([]);
  };

  const [query, setQuery] = useState("");
  const filterForms = forms.filter((form) =>
    form.formTitle.toLowerCase().includes(query.toLowerCase())
  );
  if (!isOpen) return null;
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
      // contentLabel="Example Modal"
    >
      <div
        className="selectTagmodal-content"
        style={{
          position: "relative",
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div className="create-folder-top-section">
            <div className="propertiesTop">
              <p style={{ fontFamily: "EuclidMedium", fontSize: '18px' }}>Create folder</p>
              <img
                src={propertiesCloseIcon}
                alt="propertiesCloseIcon"
                style={{ cursor: "pointer" }}
                onClick={() => onClose()}
              />
            </div>
            <div className="textInputContainer">
              <p className="propertiesText">Folder Name</p>
              <input
                className="propertiesInput"
                value={folderName}
                name="folder Name"
                placeholder="Folder Name"
                onChange={(e) => setFolderName(e.target.value)}
              />
            </div>
            <div
              style={{
                height: "1.2px",
                width: "100%",
                backgroundColor: "rgba(211, 220, 229, 1)",
              }}
            ></div>
            <div className="selected-folder-container">
              <p>{selectedFormIds.length} Selected Forms</p>
              <div className="formlist-search-box-folderselect">
                <img src={SearchBoxIcon} alt="" />
                <input
                  type="text"
                  placeholder="search..."
                  className="search-box-style"
                  style={{ width: "100%" }}
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="listof-forms-list" style={{ padding: "20px" }}>
            {filterForms?.map((form, i) => (
              <div
                className="single-file-details"
                key={i}
                onClick={() => handelSelectedFomes(form._id)}
                style={{
                  backgroundColor: selectedFormIds.includes(form._id)
                    ? "#1B51BB1A"
                    : "#F6F8FC",
                }}
              >
                <div className="inside-contaienr-formdetails">
                  <div className="img-container">
                    {
                      selectedFormIds.includes(form._id) ? <MdOutlineFileDownloadDone size={24} color="#1B51BB" />
                      : <IoDocumentTextOutline size={24} color="#8493B2" />

                    }
                  </div>
                  <div className="inside-formname-container-">
                    <p className="inside-formname-container-formname">
                      {form.formTitle}
                    </p>
                    <div className="tag-updated-date">
                      <p
                        style={{
                          fontSize: "0.8rem",
                          color: "rgba(132, 147, 178, 1)",
                        }}
                      >
                        {formatUpdatedAt(form.updatedAt)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="folder-action-container">
          <hr />
          <div className="buttons-from">
            <button
              className="folder-action-butoon1"
              onClick={handelCloseFolderModal}
            >
              Cancel
            </button>
            <button
              className="folder-action-butoon2"
              onClick={handelCreateFolderSubmit}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

const FolderView = () => {
  const [createFolder, setCreateFolder] = useState(false);
  const userId = localStorage.getItem("userId");

  const onCloseCreateFolder = () => {
    setCreateFolder(false);
  };
  const [folderList, setFolderList] = useState([]);
  const [overFile, setHoverFile] = useState(null);
  const navigate = useNavigate();
  const handelCraeteFolderCreate = async () => {
    setCreateFolder(!createFolder);
  };

  const getAllFolder = async () => {
    const Url = process.env.REACT_APP_API;
    try {
      const response = await axios.get(`${Url}/folder/allfolder`);
      if (response.status === 200) {
        setFolderList(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  useEffect(() => {
    const getAllFolder = async () => {
      const Url = process.env.REACT_APP_API;
      try {
        const response = await axios.get(`${Url}/folder/allfolder`);
        if (response.status === 200) {
          setFolderList(response.data);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    getAllFolder();
  }, []);

  const [selectedFolderIds, setSelectedFolderIds] = useState([]);
  const handelOpenFolder = (e, folderId) => {
    if (e.detail === 1) {
      if (selectedFolderIds.includes(folderId)) {
        setSelectedFolderIds(selectedFolderIds.filter((id) => id !== folderId));
      } else {
        setSelectedFolderIds([...selectedFolderIds, folderId]);
      }
    } else if (e.detail === 2) {
      navigate(`${folderId}`);
    }
  };

  function formatDate(isoDate) {
    const date = new Date(isoDate); // Convert ISO string to Date object
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );

    // Customize with "at" in between
    const [datePart, yearPart, timePart] = formattedDate.split(", ");

    return `${datePart},${yearPart} at ${timePart}`;
  }

  const [isOpenAction, setOpenAction] = useState(null);
  const handelShowAction = (folderId) => {
    setOpenAction(isOpenAction === folderId ? null : folderId);
  };
  const [folderName, setFolderName] = useState("");
  const [folderNameEdit, setFolderNameEdit] = useState(null);

  const handelChangeName = (folder) => {
    setFolderNameEdit(folder._id);
    setOpenAction(null);
    setFolderName(folder.folderName);
  };

  const changeFolderName = async (folderId) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/folders/updatefoldername/${folderId}`,
        { folderName: folderName }
      );
      console.log("data", response.status);
      if (response.status === 200) {
        getAllFolder();
        setFolderNameEdit(null);
        setFolderName("");
      }
    } catch (error) {}
  };

  const handelChangeStar = async (folder) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/folders/updatefolderstar/${folder._id}`,
        { starred: !folder.star }
      );
      console.log("data", response.status);
      if (response.status === 200) {
        getAllFolder();
        setOpenAction(null);
      }
    } catch (error) {}
  };

  const deleteFolder = async (folder) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/folders/deletefolder/${folder._id}`
      );
      console.log("data", response.status);
      if (response.status === 200) {
        getAllFolder();
        setOpenAction(null);
      }
    } catch (error) {}
  };

  const handelDeleteSelectedFodler = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/folders/deletebulkfolder`,
        {
          data: selectedFolderIds,
        }
      );
      if (response.status === 200) {
        getAllFolder();
        setSelectedFolderIds([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [query, setQuery] = useState("");
  const filterForfolder = folderList.filter((folder) =>
    folder.folderName.toLowerCase().includes(query.toLowerCase())
  );
  return (
    <>
      <CreateFormModel
        isOpen={createFolder}
        onClose={onCloseCreateFolder}
        getFolder={getAllFolder}
        userId={userId}
      />
      <div className="task-list-view">
        {selectedFolderIds.length > 0 ? (
          <div className="folder-selected-container">
            <div className="close" onClick={() => setSelectedFolderIds([])}>
              <img
                src={closeIconselectedFolder}
                alt="closeIconselectedFolder"
              />
            </div>
            <p>{selectedFolderIds.length} Selected</p>
            <div>
              <img src={shareIcon} alt="" />
            </div>
            <div onClick={handelDeleteSelectedFodler}>
              <img src={deleteIcon} alt="" />
            </div>
            <div>
              <img src={threedots} alt="" />
            </div>
          </div>
        ) : (
          <div className="formlist-search-box-container">
            <div className="formlist-search-box">
              <img src={SearchBoxIcon} alt="" />
              <input
                type="text"
                placeholder="search..."
                className="search-box-style"
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
            <ProfileBasedLinks>
              <img
                src={AddFolderIcon}
                alt=""
                className=""
                onClick={() => {
                  handelCraeteFolderCreate();
                }}
              />
            </ProfileBasedLinks>
          </div>
        )}
        <div className="folder-listview-container">
          {filterForfolder?.map((folder, i) => (
            <div className="single-folder">
              <div
                className="single-folder-view"
                style={{
                  background:
                    overFile === i || selectedFolderIds.includes(folder._id)
                      ? "rgba(27, 81, 187, 0.1)"
                      : "transparent",
                }}
                onMouseOver={() => setHoverFile(i)}
                onMouseLeave={() => setHoverFile(null)}
              >
                {console.log("folder", folder.star)}

                <img
                  src={folder.star ? folderImage_start : folderIcon}
                  alt="folderIcon"
                  onClick={(e) => handelOpenFolder(e, folder._id)}
                />
                <div className="folder-name-container">
                  <div className="folder-name">
                    {folderNameEdit === folder._id ? (
                      <input
                        value={folderName}
                        onChange={(e) => setFolderName(e.target.value)}
                        onBlur={() => changeFolderName(folder._id)}
                        className="name-input-folder"
                        style={{
                          width: "70%",
                          height: "",
                          backgroundColor: "transparent",
                        }}
                      />
                    ) : (
                      <>
                        <p>{folder.folderName}</p>
                        <img
                          src={folder_actionIcon}
                          alt="folder_actionIcon"
                          onClick={() => handelShowAction(folder._id)}
                        />
                      </>
                    )}
                    {isOpenAction === folder._id && (
                      <div className="folder-action-dropdown">
                        <ul>
                          <li onClick={() => navigate(`${folder._id}`)}>
                            Open
                          </li>
                          <li>Share</li>
                          <li onClick={() => handelChangeName(folder)}>
                            Rename
                          </li>
                          <li onClick={() => handelChangeStar(folder)}>Star</li>
                          <li onClick={() => deleteFolder(folder)}>Delete</li>
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className="folder-createtime">
                    {formatDate(folder.updatedAt)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FolderView;
